module.exports = __webpack_public_path__ + "js/stellarium-web-engine.147e9685.wasm";